// common
export const EMPTY_STATE = "EMPTY_STATE";
export const UPDATE_REQUEST_ERROR = "UPDATE_REQUEST_ERROR";
export const UPDATE_IS_LOADING = "UPDATE_IS_LOADING";

// authentication
export const UPDATE_TOKEN = "UPDATE_TOKEN";
export const UPDATE_IS_AUTHORIZED = "UPDATE_IS_AUTHORIZED";

// creatives-upload
export const UPDATE_CREATIVES_FORM = "UPDATE_CREATIVES_FORM";
export const UPDATE_CREATIVES_FORM_CAMPAIGN_BY_INDEX = "UPDATE_CREATIVES_FORM_CAMPAIGN_BY_INDEX";
export const UPDATE_CREATIVES_AUTHENTICATION = "UPDATE_CREATIVES_AUTHENTICATION";
export const UPDATE_CREATIVES_PROGRESS_MODAL = "UPDATE_CREATIVES_PROGRESS_MODAL";
